export function extractRouteIds(pathname: string): Record<string, string> {
  const ids: Record<string, string> = {};
  const grab = (re: RegExp, key: string) => {
    const match = pathname.match(re)?.[1];
    if (match && match !== "undefined") ids[key] = match;
  };
  grab(/\/projects\/([^/]+)/, "projectId");
  grab(/\/parts\/([^/]+)/, "partId");
  grab(/\/procedures\/([^/]+)/, "procedureId");
  grab(/\/operations\/([^/]+)/, "operationId");
  return ids;
}
